
import React, { useEffect, useState } from 'react';
import {  useNavigate } from "react-router";
import { SlDrawer, SlSelect, SlOption, SlButton, SlIcon } from '@shoelace-style/shoelace/dist/react';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Select from 'react-select'
import api from "../../services/api"
import config from '../../config'
import TableLoader from '../../shared/TableLoader';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast'
import { useDispatch, useSelector } from 'react-redux';
import { roles } from "../../utils/constants";
import { formatDate, formatDateYYYYMMDD, NEWISODateString } from "../../utils/dateFormat";
import Paginator from '../../shared/Paginator';
import { SetCampCount, SetOpsSales,SetComponentId } from '../../redux/counterSlice'

function CampaignDiscount() {
    const dispatch = useDispatch()
    dispatch(SetComponentId(10))
    const [show, setShow] = useState(false);
    const [companyName, SetCompany] = useState([])
    const [opsName, setopsName] = useState([])
    const [packages, setPackage] = useState(true)
    const [discount, setDiscount] = useState(false)
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false);
    const [buttonDisable, SetButtondisable] = useState(false)
    const [currentPage, setCurrentPage] = useState(0);
    const [currentDate, setCurrentDate] = useState("")
    const [totalPages, setTotalPages] = useState(0);
    const [flag, setFlag] = useState("");
    const [discid, setDiscid] = useState(0)

    const navigate = useNavigate()

    const handleClose = () => { setShow(false); setPackage(true); setDiscount(false); formik.resetForm() };
    const handleShow = () => { setShow(true) }

    const defaultValue = (options, value) => {
        return options ? options.filter((option) => option.value === value) : "";
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const APPROVED = [
        { value: 1, label: 'Raghu' },
        { value: 2, label: 'Chaitanya' }
    ]

    const check = (val) => {
        if (val === "start_date" && packages) {
            return Yup.date().required("Start Date is required")
        }
        if (val === "start_date" && !packages) {
            return Yup.date()
        }
        if (val === "end_date" && packages) {
            return Yup.date().required("End Date is required").min(
                Yup.ref('start_date'),
                "End date can't be before Start date"
            )
        }
        if (val === "end_date")
            return Yup.date()
        if (val === "paid_campaigns" && packages)
            return Yup.number().required("Paid Campaign is required").min(0, 'must be greater than or equal to 0')
        if (val === "free_campaigns" && packages)
            return Yup.number().required("Free Campaign is required").min(0, 'must be greater than or equal to 0')
        if (val === "approved_by" && !packages) {
            return Yup.string()
        }
        if (val === "discount" && discount) {
            return Yup.number().required("Discount is required").min(1, 'discount must be greater than 0').max(100, 'Discount must be less than 100')
        }
        else {
            return Yup.number()
        }
    }

    const formik = useFormik({
        initialValues: {
            company: "",
            description: "",
            start_date: "",
            end_date: "",
            paid_campaigns: 0,
            free_campaigns: 0,
            approved_by: "",
            discountby: 0,
        },
        validationSchema: Yup.object({
            company: Yup.string().required("Company Name is required"),
            start_date: check("start_date"),
            end_date: check("end_date"),
            paid_campaigns: check("paid_campaigns"),
            free_campaigns: check("free_campaigns"),
            approved_by: Yup.string().required("Approved By is Required"),
            discountby: check("discount"),
        }),
        onSubmit: async (values, { resetForm }) => {
            if (!formik.errors.length) {
                SetButtondisable(true)
                if (packages) {
                    values.discountby = 0
                }
                if (discount) {
                    values.paid_campaigns = 0
                    values.free_campaigns = 0
                    values.start_date = ""
                    values.end_date = ""
                }
                let result = { ...values, packages }
                if (flag === "add") {
                    try {
                        let res = await api({
                            url: '/user/campaign_creation/postdiscount',
                            method: 'POST',
                            responseType: 'json',
                            data: result
                        })
                        if (res) {
                            Toast('success', 'Created Successfully')
                            setCurrentPage(0);
                            getDiscountData(0, compfilter, status);
                        }
                    } catch (error) {
                        console.error(error);
                        if (error.response.status === 401)
                            navigate("/")
                    }
                }
                if (flag === "edit") {
                    result = { ...values, packages, discid }
                    try {
                        let res = await api({
                            url: '/user/campaign_creation/editdiscount',
                            method: 'POST',
                            responseType: 'json',
                            data: result
                        })
                        if (res) {
                            Toast('success', 'Updated Successfully')
                            setCurrentPage(0);
                            getDiscountData(0, compfilter, status);
                        }
                    } catch (error) {
                        console.error(error);
                        if (error.response.status === 401)
                            navigate("/")
                    }
                }
                setTimeout(() => {
                    handleClose();
                }, 2500);
            }
            // setTimeout(() => {
            //     resetForm()
            // }, 3000);
        }
    });

    useEffect(() => {
        getAdv('');
        // getOps();
        setCurrentDate(NEWISODateString().slice(0, 10))
    }, [])
    useEffect(() => {
        getDiscountData(currentPage, compfilter, status);
    }, [currentPage])

    const getDiscountData = async (page = 0, company, status) => {
        setLoader(true);
        try {
            let res = await api({
                url: '/user/campaign_creation/getdiscount',
                method: 'POST',
                responseType: 'json',
                data: {
                    page,
                    limit: config.PER_PAGE,
                    company,
                    status
                }
            })
            setData(res.data.data);
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            console.error(error);
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const getAdv = async (val) => {
        try {
            let res = await api({
                url: '/user/advertisers/getadv',
                method: 'POST',
                responseType: 'json',
                data: {
                    comp: val
                }
            })
            if (val === '') {
                SetCompany(res.data.company);
                return
            }
        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const getOps = async () => {
        try {
            let res = await api({
                url: '/user/campaign_creation/getops',
                method: 'POST',
                responseType: 'json',
            })
            setopsName(res.data)
        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const fun = (id) => {
        // for (let i = 0; i < opsName?.length; i++) {
        //     if (opsName[i]?.value === id) {
        //         return opsName[i].label
        //     }
        // }
        for (let i = 0; i < APPROVED.length; i++) {
            if (APPROVED[i].value === id) {
                return APPROVED[i].label
            }
        }
    }
    const [status, setStatus] = useState(-1);
    const [compfilter, setCompfilter] = useState("");
    const statuses = [
        {
            value: -1,
            label: "All",
        },
        {
            value: 1,
            label: "Package",
        },
        {
            value: 0,
            label: "Discount",
        },
    ];

    const changeSelectHandler = (event) => {
        setStatus(event.target.value);
        setCurrentPage(0);
        getDiscountData(0, compfilter, event.target.value);
    };

    const changeCompanyHandler = (event) => {
        setCompfilter(event.target.displayLabel);
        getDiscountData(0, event.target.displayLabel, status);
        setCurrentPage(0);
    }

    const editAction = async (index) => {
        SetButtondisable(false)
        let result = data[index]
        console.log(result)
        formik.setFieldValue('company', result.company_name)
        formik.setFieldValue('description', result.description)
        if (!result.package) {
            setDiscount(true)
            setPackage(false)
            formik.setFieldValue('discountby', result.discount)
            // ops?.map((item) => {
            //     if (item.value === result.approved_by) {
            //         formik.setFieldValue('approved_by', item.value)
            //     }
            // })
            formik.setFieldValue('approved_by', result.approved_by.toString())
        }
        if (result.package) {
            setDiscount(false)
            setPackage(true)
            formik.setFieldValue('start_date', formatDateYYYYMMDD(result.start_date))
            formik.setFieldValue('end_date', formatDateYYYYMMDD(result.end_date))
            formik.setFieldValue('paid_campaigns', result.paid_campaigns)
            formik.setFieldValue('free_campaigns', result.free_campaigns)
            // opsName?.map((item) => {
            //     if (item.value === result.approved_by) {
            //         formik.setFieldValue('approved_by', item.value)
            //     }
            // })
            formik.setFieldValue('approved_by', result.approved_by.toString())
        }
        handleShow();
    }

    return (
        <div className='discount'>
            <header className="flex items-center mb-3">
                <aside class="flex gap-3 ml-auto w-full flex-wrap">
                <h5 className='mr-auto'>Discount</h5>
                    <div>
                        <SlSelect placeholder="Select Company Name"
                            defaultValue={'all'}
                            size='small'
                            onSlChange={changeCompanyHandler} style={{ width: '200px' }}>
                            <SlIcon library="lucide" name="building" slot="prefix"></SlIcon>
                            {[{ value: 'all', label: 'All' }, ...companyName].map((option) => (
                                <SlOption key={option.value} value={option.value}>
                                    {option.label}
                                </SlOption>
                            ))}
                        </SlSelect>
                    </div>
                    <div>
                        <SlSelect placeholder="Select Status"
                            defaultValue={status} style={{ width: '200px' }}
                            onSlChange={changeSelectHandler} size='small'>
                            <SlIcon library="lucide" name="percent" slot="prefix"></SlIcon>

                            {statuses.map((option) => (
                                <SlOption key={option.value} value={option.value}>
                                    {option.label}
                                </SlOption>
                            ))}
                        </SlSelect>
                    </div>
                    {localStorage.getItem("role") === roles.ops &&
                        <SlButton
                            variant="primary"
                            size="small"
                            onClick={() => {
                                handleShow();
                                SetButtondisable(false);
                                setFlag("add");
                            }}>Add</SlButton>}
                </aside>
            </header>
            <div className='overflow-x-auto mb-4'>
            <ScrollContainer>
                <table className='table table-bordered'>
                    <thead className="sticky top-0">
                        <tr className="group/details hover:bg-slate-100">
                            <th>Company Name</th>
                            <th>Description</th>
                            <th>Package</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Paid Campaigns</th>
                            <th>Free Campaigns</th>
                            <th>Approved By</th>
                            <th>Discount(%)</th>
                            {
                                <th>Unique Code</th>}
                            {
                                localStorage.getItem("role") === roles.ops &&
                                <th>Actions</th>}
                        </tr>
                    </thead>
                    {
                        (data?.length && !loader) ?
                            <tbody>
                                {data?.map((item, index) => {
                                    return (
                                        <tr key={item.discount_id} className="group/details hover:bg-slate-100" >
                                            <td>{item.company_name}</td>
                                            <td>{item.description ? item.description : "-"}</td>
                                            <td>{item.package === 1 ? "true" : "false"}</td>
                                            <td>{item.package === 1 ? formatDate(item.start_date) : "-"}</td>
                                            <td>{item.package === 1 ? formatDate(item.end_date) : "-"}</td>
                                            <td>{item.paid_campaigns ? item.paid_campaigns : "-"}</td>
                                            <td>{item.free_campaigns ? item.free_campaigns : "-"}</td>
                                            <td>{fun(item.approved_by) || "-"}</td>
                                            <td>{item.package === 0 ? item.discount : "-"}</td>
                                            { <td>{item.unique_code}</td>}
                                            {localStorage.getItem("role") === roles.ops &&
                                                <td>
                                                    <sl-tooltip content="Edit">
                                                        <sl-icon-button
                                                            library="boxicons"
                                                            name="bx-edit"
                                                            onClick={() => { editAction(index); setFlag("edit"); setDiscid(item.discount_id) }}
                                                        />
                                                    </sl-tooltip>
                                                </td>}
                                        </tr>
                                    )
                                })}
                            </tbody> : (!data?.length && !loader) ? <NoDataFound colspan="10" /> : <TableLoader colspan="4" />
                    }
                </table>
                </ScrollContainer>
            </div>
            <div className='right-fixed'>
                {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}
            </div>

            <SlDrawer label="Discount" open={show} onSlAfterHide={handleClose} style={{ '--size': '30vw' }}>
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="" className="form-label">Company Name</label>
                        <span className="text-red-600">*</span>
                        <Select
                            // class="form-select"
                            aria-label="Default select example"
                            name="company"
                            placeholder='Select Company Name'
                            onBlur={formik.handleBlur}
                            value={defaultValue(companyName, formik.values.company)}
                            onChange={selected => { formik.setFieldValue('company', selected.value); }}
                            options={companyName}
                        >
                        </Select>
                        {formik.errors.company && formik.touched.company ? <div className="text-red-600">{formik.errors.company}</div> : null}
                    </div>
                    <div class="form-group">
                        <label className="form-check-label">Description</label>
                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" name='description' value={formik.values.description}
                            onBlur={formik.handleBlur}
                            onChange={(e) => { formik.handleChange(e) }}></textarea>
                    </div>

                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="package" value="0" id="package" checked={packages} onChange={() => { setPackage(true); setDiscount(false) }} />
                        <label className="form-check-label" htmlFor="package">
                            Package
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="discount" value="0" id="discount" checked={discount} onChange={() => { setDiscount(true); setPackage(false) }} />
                        <label className="form-check-label" htmlFor="disc">
                            Discount
                        </label>
                    </div>
                    {
                        packages ?
                            <div>
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Start Date</label>
                                    <span className="text-red-600">*</span>
                                    <input type="date" className="form-control" placeholder="" aria-label="" name="start_date"
                                        value={formik.values.start_date}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        min={currentDate}
                                    />
                                    {formik.errors.start_date && formik.touched.start_date ? <div className="text-red-600">{formik.errors.start_date}</div> : null}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">End Date</label>
                                    <span className="text-red-600">*</span>
                                    <input type="date" className="form-control" placeholder="" aria-label="" name="end_date"
                                        value={formik.values.end_date}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        min={currentDate} />
                                    {formik.errors.end_date && formik.touched.end_date ? <div className="text-red-600">{formik.errors.end_date}</div> : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Paid Campaigns</label>
                                    <span className="text-red-600">*</span>
                                    <input type="number" className="form-control" placeholder="Enter paid campaigns" aria-label="" name="paid_campaigns"
                                        value={formik.values.paid_campaigns}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.errors.paid_campaigns && formik.touched.paid_campaigns ? <div className="text-red-600">{formik.errors.paid_campaigns}</div> : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Free Campaigns</label>
                                    <span className="text-red-600">*</span>
                                    <input type="number" className="form-control" placeholder="Enter Free campaigns" aria-label="" name="free_campaigns"
                                        value={formik.values.free_campaigns}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.errors.free_campaigns && formik.touched.free_campaigns ? <div className="text-red-600">{formik.errors.free_campaigns}</div> : null}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Approved By</label>
                                    <span className="text-red-600">*</span>
                                    <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="approved_by"
                                        placeholder='Select Approved By'
                                        value={formik.values.approved_by}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    >   <option value="" selected>Select Approved By</option>
                                        <option value="1">Raghu</option>
                                        <option value="2">Chaitanya</option>
                                    </select>
                                    {/* <Select
                                        aria-label="Default select example"
                                        name="approved_by"
                                        placeholder='Select Approved By'
                                        onBlur={formik.handleBlur}
                                        value={defaultValue(opsName, formik.values.approved_by)}
                                        onChange={selected => { formik.setFieldValue('approved_by', selected.value) }}
                                        options={opsName}
                                    >
                                    </Select> */}
                                    {formik.errors.approved_by && formik.touched.approved_by ? <div className="text-red-600">{formik.errors.approved_by}</div> : null}
                                </div>
                            </div> :
                            <div>
                                <div><label htmlFor="" className="form-label">Discount(%)</label>
                                    <span className="text-red-600">*</span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="" placeholder="Enter percentage"
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        value={formik.values.discountby}
                                        name="discountby"
                                    />
                                    {formik.errors.discountby && formik.touched.discountby ? <div className="text-red-600">{formik.errors.discountby}</div> : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Approved By</label>
                                    <span className="text-red-600">*</span>
                                    {/* <Select
                                        aria-label="Default select example"
                                        name="approved_by"
                                        placeholder='Select Approved By'
                                        onBlur={formik.handleBlur}
                                        value={defaultValue(opsName, formik.values.approved_by)}
                                        onChange={selected => { formik.setFieldValue('approved_by', selected.value) }}
                                        options={opsName}
                                    >
                                    </Select> */}
                                    <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="approved_by"
                                        placeholder='Select Approved By'
                                        value={formik.values.approved_by}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                    >   <option value="" selected>Select Approved By</option>
                                        <option value="1">Raghu</option>
                                        <option value="2">Chaitanya</option>
                                    </select>
                                    {formik.errors.approved_by && formik.touched.approved_by ? <div className="text-red-600">{formik.errors.approved_by}</div> : null}
                                </div>

                            </div>}

                    <SlButton variant="success" type='submit' disabled={buttonDisable}>Submit</SlButton>
                </form>
            </SlDrawer>
        </div>
    )
}
export default CampaignDiscount;